<!--<div class="logo-wrapper" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">-->
<!--   <app-icon [width]="150" [height]="31" [fixedSize]="true" icon="logo"></app-icon>-->
<!--</div>-->

<img
  [src]="logoUrl"
  alt="Special features"
  [width]="width"
  [height]="height"
  style="transform: scale({{ scale}});"
/>
